class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle || this.hasAttribute('no-details')) return;
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    console.log(this);

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    if (!this.mainDetailsToggle || this.hasAttribute('no-details')) return;
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.mainDetailsToggle || this.hasAttribute('no-details')) return;
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle || this.hasAttribute('no-details')) return;
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    if (this.classList.contains('mega-menu') && this.classList.contains('menu-hover')) {
      this.megaMenuDelay();
      window.addEventListener('scroll', () => { this.removeAttribute('hovered') })
    }

  }

  onToggle() {
    if (!this.mainDetailsToggle || this.hasAttribute('no-details')) return;
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  megaMenuDelay() {
    let timer;
    const duration = 200;

    const startTimer = () => {
      clearTimeout(timer);

      timer = setTimeout(() => {
        this.setAttribute('hovered', '');

        if (this.header.hasAttribute('side-menu')) {
          this.style.setProperty('--content-index', -1);
        }
      }, duration);
    }
    const resetTimer = () => {
      clearTimeout(timer);

      timer = setTimeout(() => {
        this.removeAttribute('hovered');
        if (this.header.hasAttribute('side-menu')) {
          setTimeout(() => {
            this.style.setProperty('--content-index', -2);
          }, 200)
        }

      }, duration);
    }

    const resetTimer0 = () => {
      clearTimeout(timer);
      const resetTime = this.header.hasAttribute('side-menu') ? duration : 0;
      timer = setTimeout(() => {
        this.removeAttribute('hovered');
        if (this.header.hasAttribute('side-menu')) {
          setTimeout(() => {
            this.style.setProperty('--content-index', -2);
          }, 200)
        }

      }, resetTime);

    }

    this.addEventListener('mouseenter', startTimer);
    this.addEventListener('mouseleave', resetTimer);
    this.header.addEventListener('mouseleave', resetTimer0);
  }
}

customElements.define('header-menu', HeaderMenu);
